(function sidebar() {

  // run init only when bundleSummary is available
  var bundleSummary = document.querySelector('.bundle-builder-app--bundle--summary');

  if (!bundleSummary) {
    setTimeout(sidebar, 100);
    return;
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(function () {
      if (bundleSummary) {
        bundleSummary.style.top = '0px';
        var bundleSummaryRect = bundleSummary.getBoundingClientRect();
        if (bundleSummaryRect.top < 30) {
          bundleSummary.style.top = Number(30 + Math.abs(bundleSummaryRect.top)).toFixed() + 'px';
        } else {
          bundleSummary.style.top = '0px';
        }
      }
    });
  })

})();